import LandlordIdentifier from './LandlordIdentifier'

export default LandlordIdentifier
